import Api from "../utils/api";

class HomeService {
  static admin = {
    get: async (params = {}) => Api.createResponse("app/admin/home/", params),
    viewActivity: async (params = {}) =>
      Api.createResponse("app/admin/home/view-activity", params),
    viewContent: async (params = {}) =>
      Api.createResponse("app/admin/home/view-content", params),
  };

  static client = {
    get: async (params = {}) => Api.createResponse("app/client/home/", params),
    viewActivity: async (params = {}) =>
      Api.createResponse("app/client/home/view-activity", params),
    viewContent: async (params = {}) =>
      Api.createResponse("app/client/home/view-content", params),
  };
}

export default HomeService;
